import { LINK_TYPES } from '../../models/BaseBanner';

class BaseBannerSerializer {
  static deSerialize(data) {
    let linkType = LINK_TYPES.NONE;
    if (data.IHBTipoLink === 1) {
      linkType = LINK_TYPES.TO_CATEGORY;
    } else if (data.IHBTipoLink === 3) {
      linkType = LINK_TYPES.TO_PRODUCT;
    } else if (data.IHBTipoLink === 4) {
      linkType = LINK_TYPES.TO_MESSAGE;
    } else if (data.IHBTipoLink === 5) {
      linkType = LINK_TYPES.TO_LINK;
    } else if (data.IHBTipoLink === 6) {
      linkType = LINK_TYPES.TO_MESSAGE_VIDEO;
    }
    return {
      buttonColor: data.IHBBotonColor,
      buttonText: data.IHBBotonTexto,
      buttonTextColor: data.IHBBotonColorTexto,
      description: data.IHBDescripcion,
      id: data.IHBImagen,
      imageUrl: data.IHBImagen,
      index: data.IHBOrden,
      linkType,
      linkValue: data.IHBIdLink,
      subtitle: data.IHBSubTitulo,
      textColor: data.IHBTextoColor,
      title: data.IHBTitulo,
      message: data.IHBMensajeLink || 'Prueba',
    };
  }
}

export { BaseBannerSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/BaseBannerSerializer.js